import type { NuxtApp } from "nuxt/app";

/**
 * Check if the URL of the current page contains "_probes"
 * @param nuxtApp The NuxtApp, needed to get the page URL while on the server
 * @returns boolean
 */
export const isProbeUrl = ( nuxtApp: NuxtApp ) => {
  let url: string;

  if ( import.meta.server ) {
    if ( !nuxtApp.ssrContext ) {
      throw new Error( "SSR Context not provided" );
    }
    url = `https://${nuxtApp.ssrContext.event.node.req.headers.host}${nuxtApp.ssrContext.url}`;
  } else {
    url = window.location.href;
  }

  return url.includes( "/_probes" );
};
